<template>
    <div>
        <b-form-input type="date" v-model="model" @change="update()" placeholder="Enter birthdate"></b-form-input>
    </div>
</template>

<script>

export default {
    props: ['placeholder', 'title', 'value'],
    data() {
        return {
            model: null
        }
    },
    created() {
        this.model = this.formatDate(this.value);
    },
    watch: {
        value(newValue) {
            this.model = this.formatDate(newValue);
        }
    },

    methods: {
        formatDate(date) {
            return this.$moment.utc(date).local().format('YYYY-MM-DD');
        },
        update() {
            this.$emit('input', this.formatDate(this.model));
        }
    }

}
</script>

<style>

</style>
